import AudienceListing from './AudienceListing.vue'
import { RouteRecordRaw } from 'vue-router'

const audiencListingRoute: RouteRecordRaw = {
  name: 'audience',
  path: 'audience',
  component: AudienceListing,
  meta: {
    requireAuth: false,
    title: 'Audience'
  }
}

export default audiencListingRoute
